import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RechargeRequestsPort } from "../../../app/ports/audit/recharge-requests.port";
import {
  CreateRechargeRequest,
  EmployeeAccessResponse,
  InternalUserByRoleResponse,
  RechargeRequestsPageResponse,
  RechargeRequestResponse,
} from "../../../domain/models/audit/recharge-requests.model";
import { EnvMicroAudit } from "../../config/env.micro.audit";
import { AUDIT_ENV } from "../../config/micros-env.tokens";

@Injectable()
export class RechargeRequestsHttpAdapter implements RechargeRequestsPort {
  private static readonly PATH = "/api/v1/recharge-requests";
  private static readonly EMPLOYEE_ACCESS_BY_IDENTITY_USER_PATH = "/api/v1/internal/employee-access/by-identity-user";
  private static readonly USERS_BY_ROLE_PATH = "/api/v1/internal/users";

  constructor(
    private readonly http: HttpClient,
    @Inject(AUDIT_ENV) private readonly environment: EnvMicroAudit,
  ) {}

  getRequests(search = ""): Observable<RechargeRequestsPageResponse> {
    const baseUrl = `${this.environment.host}${this.environment.apiBasePath}`.replace(/\/$/, "");
    const normalizedSearch = search.trim();
    const params = normalizedSearch ? new HttpParams().set("search", normalizedSearch) : undefined;
    return this.http.get<RechargeRequestsPageResponse>(`${baseUrl}${RechargeRequestsHttpAdapter.PATH}`, { params });
  }

  getEmployeeAccessByIdentityUser(employeeId: number): Observable<EmployeeAccessResponse> {
    const baseUrl = this.baseUrl();
    return this.http.get<EmployeeAccessResponse>(
      `${baseUrl}${RechargeRequestsHttpAdapter.EMPLOYEE_ACCESS_BY_IDENTITY_USER_PATH}/${employeeId}`,
    );
  }

  getUsersByRole(roleId: number): Observable<readonly InternalUserByRoleResponse[]> {
    const params = new HttpParams().set("roleId", roleId);
    return this.http.get<InternalUserByRoleResponse[]>(`${this.baseUrl()}${RechargeRequestsHttpAdapter.USERS_BY_ROLE_PATH}`, { params });
  }

  createRechargeRequest(payload: CreateRechargeRequest): Observable<RechargeRequestResponse> {
    return this.http.post<RechargeRequestResponse>(`${this.baseUrl()}${RechargeRequestsHttpAdapter.PATH}`, payload);
  }

  private baseUrl(): string {
    return `${this.environment.host}${this.environment.apiBasePath}`.replace(/\/$/, "");
  }
}
